import { EPermissoes } from '@/enums/ePermissoes';

export default [
  {
    description: 'Regional',
    path: 'regional',
    name: 'regional',
    component: () => import('@/views/gestao/regional/Index.vue'),
    meta: {
      permissions: [EPermissoes.CadastroObra],
      groups: [],
      escopoObra: 'global'
    },
    goesToMenu: true
  },
  {
    description: 'Inclusão de Regional',
    parent: 'regional',
    path: 'regional/incluir',
    name: 'regionalinsert',
    component: () => import('@/views/gestao/regional/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'regional',
      permissions: [EPermissoes.CadastroObra],
      groups: []
    }
  },
  {
    description: 'Edição de Regional',
    parent: 'regional',
    path: 'regional/editar/:id',
    name: 'regionalupdate',
    component: () => import('@/views/gestao/regional/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'regional',
      permissions: [EPermissoes.CadastroObra],
      groups: []
    }
  }
];
